import React from "react";
import {
  BasicInformation,
  EducationalInformation,
  ProfessionalInformation,
  RightArrow,
} from "../../utils/icons";
import { useNavigate } from "react-router-dom";
import { Gauge } from "@ant-design/charts";
import { Progress } from "antd";
import { useSelector } from "react-redux";

const TextBox = ({ icon, title, btn, navigate, percentage }) => {
  const roundedPercentage = percentage?.toFixed(1);
  console.log("🚀 ~ TextBox ~ navigate:", navigate);
  const navigation = useNavigate();

  const handleNavigate = () => {
    if (typeof navigate === "string") {
      // If navigate is just a string path
      navigation(navigate);
    } else if (
      typeof navigate === "object" &&
      navigate.path &&
      navigate.state
    ) {
      // If navigate is an object with path and state
      navigation(navigate.path, { state: navigate.state });
    }
  };
  return (
    <div className="grid grid-cols-12 mx-auto items-center  w-full">
      <div className="col-span-4 flex items-center gap-5">
        {icon}
        <h1 className="font-semibold">{title}</h1>
      </div>

      <div className="col-span-4 flex justify-center items-center ml-12">
        <Progress size={[100, 5]} percent={roundedPercentage} />
      </div>
      <div className="col-span-4 flex justify-center items-center ml-12">
        <button
          onClick={handleNavigate}
          className="flex items-center justify-center gap-2 text-sm text-DarkGrey"
        >
          {btn}
          <RightArrow />
        </button>
      </div>
    </div>
  );
};

function ProfileCompletionWidget() {
  const profileCompletion =
    useSelector((state) => state?.user?.profileCompletion) || {};

  console.log({ profileCompletion });
  const percantage =
    profileCompletion?.profileCompletenessInPercentage?.toFixed(1) || 0;

  const config = {
    // percent: 0.50,
    range: {
      // color: "l(0) 0:#B8E1FF 1:#3D76DD",
      ticks: [0, percantage / 100, 1],
      color: "l(0) 0:#FFA380 0.5:#FFA458 1:#E3302E",
    },
    // range: {
    //   ticks: [0, 1],
    //   color: ["l(0) 0:#FFA380 0.5:#FFA458 1:#E3302E"],
    // },
    startAngle: Math.PI,
    endAngle: 2 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        // offsetY: -10,
        style: {
          fontSize: "30px",
          color: "#000000",
          fontWeight: "bold",
        },
        formatter: () => `${percantage}% Completed`,
      },
      //   content: {
      //     style: {
      //       fontSize: "24px",
      //       lineHeight: "44px",
      //       color: "#4B535E",
      //     },
      //     formatter: () => "加载进度",
      //   },
    },
  };
  const { section } = profileCompletion;
  console.log(section, "Sectionnnnnnnnnnnnnnnnnn");
  const keys = [
    "Profile#BasicInfo",
    "Profile#EducationalInfo",
    "Profile#ProfessionalInfo",
  ];
  const profiles = section && keys?.map((key) => section[key]);

  console.log({ profiles }, "HELLO WORLD");

  return (
    profiles?.length > 0 && (
      <div className="m-auto   rounded-2xl p-5 shadow-shadowOne overflow-auto bg-pureWhite h-full">
        <h1 className="font-semibold text-lg ">Profile Completion</h1>

        <Gauge
          style={{
            width: "400px",
            height: "200px",
            alignItems: "center",
            placeItems: "center",
            margin: "0 auto",
          }}
          {...config}
        />
        <div className="m-auto space-y-5 flex flex-col mt-10">
          <TextBox
            icon={<BasicInformation />}
            title="General"
            btn="Update Details"
            navigate={{ path: "/portfolio", state: { tab: 1 } }}
            percentage={profiles[0]?.Percentage}
          />
          <TextBox
            icon={<EducationalInformation />}
            title="Educational"
            btn="Complete Details"
            navigate={{ path: "/portfolio", state: { tab: 2 } }}
            percentage={profiles[1]?.Percentage}
          />
          <TextBox
            icon={<ProfessionalInformation />}
            title="Professional"
            btn="Complete Details"
            navigate={{ path: "/portfolio", state: { tab: 3 } }}
            percentage={profiles[2]?.Percentage}
          />
        </div>
      </div>
    )
  );
}

export default ProfileCompletionWidget;
